import { render } from "./ConfirmTravelPass.vue?vue&type=template&id=c2a09b56&scoped=true&lang=pug"
import script from "./ConfirmTravelPass.vue?vue&type=script&lang=ts"
export * from "./ConfirmTravelPass.vue?vue&type=script&lang=ts"

import "./ConfirmTravelPass.vue?vue&type=style&index=0&id=c2a09b56&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c2a09b56"

export default script